// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.block_head-text[data-v-346ca75e] {\n    font-size: 32px;\n    color: var(--grey-color);\n    font-weight: 600;\n    line-height: 48px;\n    margin: 33px 0;\n}\n.error-list[data-v-346ca75e] {\n    list-style-type: none;\n}\n.main_layer[data-v-346ca75e] {\n    background-image: url('/images/purchases_head.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    min-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
